import { CLO } from '../types';
export default {
  type: CLO,
  service: '0xinfra.com',
  url: 'https://clo-geth.0xinfra.com/',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
